import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import {
  AfterViewChecked,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { ChatEmitterService } from "@app/core/services/chat-emitter.service";
import { ChatService } from "@app/core/services/chat.service";
import { HelperService } from "@app/core/services/helper.service";
import { AppConfig } from '@app/core/Utilities/app-config.service';
import { ExcelFileExtension } from '@app/modules/agent/pages/agent-activity-detail/agent-activity-detail.component';
import { AgentDetailComponent } from '@app/modules/agent/pages/agent-detail/agent-detail.component';
import * as _ from "lodash";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: "app-user-chat-window",
  templateUrl: "./user-chat-window.component.html",
  styleUrls: ["./user-chat-window.component.scss"],
})
export class UserChatWindowComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy, DoCheck {
  @Input() receiverInfo: any;
  @Input() fromParent: boolean;
  @Output() closePopoverRef = new EventEmitter();
  @Input() chatID: any;
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  @ViewChild("autosize") autosize: CdkTextareaAutosize;
  @ViewChild("deleteMessageTemplate") deleteMessageTemplate: ElementRef;
  public displayHeader = false;
  userId: any;
  chatObject: any;
  chatMessages = [];
  SenderId: any;
  senderInfo: any;
  receiverId: any;
  messageText = "";
  fromUrl = false;
  throttle = 200;
  scrollUpDistance = 5;
  pageNo = 1;
  bsModalRef: BsModalRef;

  @ViewChild("fileUploder") public fileUploder: any;
  public onUploadClicked: Subject<any> = new Subject();
  public uploadImagesFormData: FormData;
  public fileUploaderSettings = {
    name: "fileUploader1",
    url: "",
    disabled: false,
    styleClass: "customUploadIcon chat-file-upload",
    allowMultiple: false,
    mode: "advanced",
    accept:
      "image/*, application/msword, application/pdf, .doc,.docx",
    maxFileSize: 5000000,
    auto: false,
    chooseLabel: "",
    uploadLabel: "Upload",
    cancelLabel: "Cancel",
    showUploadButton: false,
    showCancelButton: false,
    customUpload: true,
    fileLimit: 1,
    files: "",
  };
  uploadedFiles = [];
  fileUploaderData: any;
  fileExtension: any = ExcelFileExtension;
  fileUploaders: any[];

  constructor(
    private sanit: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private chatService: ChatService,
    private helperService: HelperService,
    private authService: AuthenticationService,
    private chatEmitterService: ChatEmitterService,
    private modalService: BsModalService,
    private _toaster: ToastrService,
    private _appConfig: AppConfig
  ) {
    this.setSenderId();
    this.activatedRoute.params.subscribe((param) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(param.id)) {
        this.fromUrl = true;
        this.chatID = param.id;
        this.chatMessages = [];
        if (this.chatID > 0) {
          this.getUserChat(this.chatID, this.pageNo, 0, 0);
        }
      }
    });

    this.activatedRoute.queryParams.subscribe((param) => {
      if (this.chatID > 0) {
        this.chatMessages = [];
        this.getUserChat(this.chatID, this.pageNo, 0, 0);
      } else if (!this.helperService.isUndefinedOrNullOrEmpty(param.rid)) {
        this.fromUrl = true;
        this.chatMessages = [];
        this.getUserChat(this.chatID, this.pageNo, this.SenderId, param.rid);
      }
    });
  }

  ngOnInit() {
    this.setSenderId();

    this.fileUploaders = [
      {
        fileUploaderSettings: this.fileUploaderSettings,
        uploadedFiles: this.uploadedFiles,
      },
    ];
    this.fileUploaderData = _.cloneDeep(this.fileUploaders);

    if (this.chatEmitterService.newMessageSubscription === undefined) {
      this.chatEmitterService.newMessageSubscription = this.chatEmitterService.newMessage.subscribe(
        (data) => {
          if (this.chatID > 0 || (this.SenderId > 0 && this.receiverId > 0)) {
            if (+this.authService.getUserInformation()["ID"] === +data.UserId) {
              this.pageNo = 1;
              this.getUserChat(
                this.chatID,
                this.pageNo,
                this.SenderId,
                this.receiverId
              );
            }
          }
        }
      );
    }
  }

  ngDoCheck() {
    if (
      this.fileUploder &&
      this.fileUploder.fileUpload &&
      this.fileUploder.fileUpload.files
    ) {
      if (!this.fileUploder.fileUpload.files.length) {
        this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
      }
    }

    this.resetSize();
  }

  ngOnDestroy() {
    this.chatID = 0;
    this.SenderId = 0;
    this.receiverId = 0;
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  ngOnChanges() {
    this.setSenderId();
    this.pageNo = 1;
    if (
      !this.helperService.isUndefinedOrNullOrEmpty(this.chatID) &&
      this.chatID > 0
    ) {
      this.chatMessages = [];
      this.getUserChat(this.chatID, 1, 0, 0);
    } else {
      this.chatMessages = [];
      this.receiverId = this.receiverInfo.UserID;
      this.getUserChat(0, 1, this.SenderId, this.receiverInfo.UserID);
    }
  }

  archiveChat() {
    this.chatService.archiveChat(this.chatID).subscribe((result) => {
      this.bsModalRef.hide();
      this.chatService.setuserArchiveChat();
      this.back();
    });
  }

  setSenderId() {
    this.SenderId = +this.authService.getUserInformation()["ID"];
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
    }
  }

  getUserChat(id, pageno, senderId, receiverId) {
    if (this.SenderId <= 0) {
      this.setSenderId();
    }
    this.chatService
      .getUsersChatId(id, pageno, senderId, receiverId)
      .subscribe((result) => {
        if (
          result.Status === ResultStatus.Success &&
          !this.helperService.isUndefinedOrNullOrEmpty(result.Data)
        ) {
          this.chatObject = result.Data;
          // this.chatMessages = result.Data.ChatMessages;
          if (result.Data.ID) {
            this.chatID = result.Data.ID;
          }
          if (
            !this.helperService.isUndefinedOrNullOrEmpty(
              result.Data.ChatMessages
            )
          ) {
            this.addItems(result.Data.ChatMessages);
          }
          if (this.chatObject.ChatMembers) {
            this.senderInfo = this.chatObject.ChatMembers.filter(
              (x) => x.UserID === this.SenderId
            )[0];
            this.receiverInfo = this.chatObject.ChatMembers.filter(
              (x) => x.UserID !== this.SenderId
            )[0];
            this.receiverId = this.receiverInfo.UserID;
            if (this.senderInfo.UnreadCount > 0) {
              this.markAsReadMessage();
            }
          }
        }
      });
  }

  markAsReadMessage() {
    if (this.chatID > 0) {
      this.chatService.readMessage(this.chatID).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.chatService.getActiveUsersChat();
        }
      });
    }
  }

  sendMessage() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.messageText)) {
      this.messageText = this.messageText.trim();
    }
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.messageText) ||
      (this.fileUploder && this.fileUploder.fileUpload.files.length > 0)) {
      const formData: FormData = new FormData();

      for (const file of this.fileUploder.fileUpload.files) {
        this.messageText = "";
        formData.append("file", file, file.name);
      }

      let postData;
      const ChatMessage = {
        ChatId: this.chatID,
        SenderId: this.SenderId,
        ReceiverId: this.receiverId,
        Message: this.messageText,
      };

      postData = JSON.stringify(ChatMessage);
      formData.append("json", postData);
      for (const file of this.fileUploder.fileUpload.files) {
        this.messageText = "";
        this.removeFile(file.name);
      }
      this.chatService.updateChat(formData).subscribe((result) => {
        this.messageText = "";
        this.resetSize();
        if (result.Status === ResultStatus.Success) {
          this.chatID = result.Data.ID;
          this.pageNo = 1;
          this.getUserChat(this.chatID, this.pageNo, 0, 0);
        }
      });
    }
  }

  onScrollDown() {
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  closePopover(value) {
    this.closePopoverRef.emit(value);
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  scrollToBottom(): void {
    try {
      if (this.pageNo <= 1) {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      }
    } catch (err) { }
  }

  addItems(responseData) {
    responseData.forEach((element) => {
      if (this.chatMessages.findIndex((item) => item.ID === element.ID) < 0) {
        this.chatMessages.push(element);
      } else {
        this.chatMessages[
          this.chatMessages.findIndex((item) => item.ID === element.ID)
        ] = element;
      }
    });
    const messages = this.chatMessages;
    this.chatMessages = _.orderBy(messages, ["DateCreated"], ["asc"]);
  }

  onScrollUp() {
    this.pageNo++;
    this.getUserChat(this.chatID, this.pageNo, this.SenderId, this.receiverId);
  }

  back() {
    this.router.navigate(["/direct-message"]);
  }

  openDeleteConfirmation() {
    this.bsModalRef = this.modalService.show(
      this.deleteMessageTemplate,
      Object.assign({}, { class: "modal-lg" })
    );
  }

  resetSize() {
    if (!this.messageText && this.autosize) {
      this.autosize.resizeToFitContent(true);
    }
  }

  // Common File Uploader Methods
  filesUpload($event) {
    if (!$event) {
      return;
    }
    if (!$event.length) {
      return;
    }

    this.uploadImagesFormData = new FormData();
    let i = 0;
    // var binary = new Binary[5];
    for (const file of $event) {
      this.uploadImagesFormData.append("file", file, file.name);
      i++;
    }
  }

  onFilesSelect($event) {
    if (this.fileUploder && this.fileUploder.fileUpload.files.length > 0) {
      if (
        !!this.fileUploder &&
        this.fileUploder.fileUpload.files.length >
        this.fileUploaders[0].fileUploaderSettings.fileLimit
      ) {
        this._toaster.error(
          "You can upload maximum " +
          this.fileUploaders[0].fileUploaderSettings.fileLimit +
          " file",
          this._appConfig.toasterError
        );
        this.fileUploder.fileUpload.remove();
        this.fileUploder.fileUpload.files = [];
        return;
      }
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return "0 GB";
    }
    if (isNaN(parseInt(bytes))) {
      return bytes;
    }
    if (typeof bytes === "string") {
      bytes = parseInt(bytes);
    }
    if (bytes === 0) {
      return "0";
    }
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }

  removeFile(fileName: any) {
    let index = 0;
    this.fileUploder.fileUpload.files.forEach((element) => {
      if (element.name === fileName) {
        this.fileUploder.fileUpload.files.splice(index, 1);
      }

      index++;
    });

    if (!this.fileUploder.fileUpload.files.length) {
      this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
    }
  }

  hasFile(message) {
    return _.startsWith(message, "<Attechment", 0);
  }

  getFileData(message) {
    return JSON.parse(message.replace("<Attechment", "").replace("data=", "").replace("/>", "").trim());
  }
}
